<script >

import TrashIcon from "../icons/TrashIcon.vue";
import EditIcon from "../icons/EditIcon.vue";
import RouterLinkTo from "../small_components/RouterLinkTo.vue";
import TablesSlot from "../small_components/tables/TablesSlot.vue";
import DefaultBox from "../slots/DefaultBox.vue";
import NotifierBlock from "../parts/NotifierBlock.vue";
import HeaderBlock from "../parts/HeaderBlock.vue";
import AsideDashboard from "../small_components/AsideDashboard.vue";
import Switcher from "../small_components/Switcher.vue";
import SearchInput from "../small_components/SearchInput.vue";
import {axiosCommittees, axiosCompanyEquipment} from "../../helpers/axios_requests";
import {ROUTES_NAMES as route_names} from "../../router";

export default {
  name: 'CompanyEquipmentLayout',
  components: {
    TrashIcon,
    NotifierBlock,
    HeaderBlock,
    AsideDashboard,
    Switcher,
    EditIcon,
    RouterLinkTo,
    SearchInput,
    DefaultBox,
    TablesSlot,

  },

  computed: {
    route_names() {
      return route_names
    }
  },
  beforeMount() {
  },

  data() {
    return {
      getUserRoleIsAdmin: true,
      loading: true,
      search: '',
      equipments: [],
      pagination: [],
    }
  },

  created() {
    this.loading = false;
    this.fetchList()
  },
  methods: {
    searchFetchList() {
      return true;
    },

    fillData({items}) {
      this.equipments = items || []
    },

    fetchList() {
      this.loading = true
      axiosCompanyEquipment.list()
          .then(r => {
            console.log(r.data)
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },
    deleteCommittee(id) {
      this.loading = true
      axiosCommittees.delete(id)
          .then(r => this.fetchList())
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>

<template>
  <div class="users-layout">
    <default-box
        :loader="loading">
      <router-view/>
      <div class="d-flex justify-content-between align-items-center mb-10">
        <div></div>
        <router-link-to
            default_button
            :route_name="route_names.company_equipment"
            :route_params="{id: 0}">
          {{ $t('tables.new_neuter') }}
        </router-link-to>
      </div>
      <tables-slot
          :empty_spacer="loading"
          @paginationFetch="fillData"
          @popstateEvent="fetchList"
          :pagination="pagination">
        <template v-slot:table_head>
          <td class="w-0 text-nowrap">#</td>
          <td class="w-0 text-nowrap">{{ $t('tables.title') }}</td>
          <td class="w-0 text-nowrap">{{ $t('tables.edit') }}</td>
        </template>
        <template v-slot:table_body>
          <tr v-for="equipment in equipments">
            <td class="w-0 text-nowrap">
              {{ equipment.id }}
            </td>
            <td class="w-0 text-nowrap">
              {{ equipment.title }}
            </td>

            <td class="w-0 text-nowrap">
              <router-link-to
                  class="d-inline-block px-10 py-10"
                  :route_params="{id: equipment.id}"
                  :route_name="route_names.company_equipment">
                <edit-icon/>
              </router-link-to>
            </td>
          </tr>
        </template>
      </tables-slot>
    </default-box>
    <notifier-block/>
  </div>

</template>

<style scoped>

</style>